import createSelectors from './createSelectors';
import ProjectTrack from '../models/ProjectTrack';

const Select = createSelectors(ProjectTrack, {});

export default Select;
